import {css} from "@emotion/react";


const styles = {
    loginContainer: css`
        form {
            width: 100%;
        }
        
        a {
            text-decoration: underline;
            color: #777E90;
        }
        
        .select-container {
            z-index: 99;
            outline: none;
            border-radius: 12px;
            border: 2px solid #2D3748;
            
            &:hover{
                outline: none;
            }
        }
    `,
    continueText : css`
        display: flex;
        width: 100%;
        align-items: center;
        text-align: center;
        
        &::before,&::after {
            content: "";
            flex: 1;
            height: 1px;
            background-color: #777E90;
            margin: 0 13px;
        }
    `,
    terms: css`
        color: #8996A9;

        p:not(:last-child)::after {
            content: "";
            display: inline-block;
            width: 3px;
            height: 3px;
            border-radius: 50%;
            background-color: #8996A9;
            margin: 4px 13px;
        }

    `
}

export default styles